import React, { Component } from 'react';

interface IProps {
    onClick(v: any): void;
}

export class PreviousButton extends Component<IProps, any> {
    render() {
        return (
            <div className='btn-secondary previous' onClick={this.props.onClick}>Previous</div>
        );
    }
}
